import { render } from "./ColorFamily.vue?vue&type=template&id=058860ad&scoped=true"
import script from "./ColorFamily.vue?vue&type=script&lang=js"
export * from "./ColorFamily.vue?vue&type=script&lang=js"

import "./ColorFamily.vue?vue&type=style&index=0&id=058860ad&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-058860ad"]])

export default __exports__